import { type JanusCtx, type Row, type LogRow, activeStatuses, ec, ecId, ecLean, requiredInt } from './context.js';
import { manaReductionDelta } from '../resources/reduction-guard.js';

export const resourceReductionReaders = (ctx: JanusCtx) => ({ ...ctx.read, statuses: (row: Row) => activeStatuses(ctx, row) });

export function preventedReductionRow(holderId: string, resource: 'mana' | 'charges'): LogRow {
    return { roll_type_1: 'resource_reduction_prevented', roll_type_2: resource, roll_item_id: null,
        roll_by: holderId, roll_to: holderId, roll_result: 0,
        rolls_full: [[0, `No ${resource} spent: ${resource} cannot be reduced.`]] };
}

/** Explain a real attempted reduction once per holder/resource in this action. No resource mutation or recompile. */
export function logPreventedReduction(ctx: JanusCtx, holder: Row, resource: 'mana' | 'charges'): void {
    if (ctx.rows.some(row => row.roll_type_1 === 'resource_reduction_prevented' && row.roll_type_2 === resource && row.roll_to === ecId(holder))) return;
    ctx.rows.push(preventedReductionRow(ecId(holder), resource));
}

/** The sole ability-lane mana writer. Return the applied value so triggers observe the actual spend. */
export function setMana(ctx: JanusCtx, holder: Row, requested: number): number {
    const before = requiredInt(ecLean(holder, 'mana'), 'resource_reduction:mana-not-held');
    const delta = manaReductionDelta(holder, requested - before, resourceReductionReaders(ctx));
    if (requested < before && delta === 0) logPreventedReduction(ctx, holder, 'mana');
    const after = before + delta;
    if (after !== before) ec(holder).mana = after;
    return after;
}
